import React from 'react';
import PropTypes from 'prop-types';
import { PropsContext } from '@uhg-abyss/web/hooks/usePropsContext/PropsContext';
import { PayerSelect } from './PayerSelect';

export const Widget = (props) => {
  const widgetProps = { ...props };

  return (
    <PropsContext.Provider value={widgetProps}>
      <PayerSelect {...props} />
    </PropsContext.Provider>
  );
};

Widget.displayName = 'utility/PayerSelect';

Widget.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    payerId: PropTypes.string,
    application: PropTypes.string,
  }),
  events: PropTypes.shape({}),
  styles: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {
    title: 'Payer Select',
  },
  events: null,
  styles: null,
};
